<template>
<div class="site-header" style="padding:0;">

   <div class="row el-container" style="background:#fff !important;" v-if="$teras.app.device=='desktop'"> 
      <div class="col s6 yo-align-left" style="height:160px;overflow:hidden;"><a href="/"><img src="../assets/logo.png" style="height:90px;margin-top:30px;margin-left:20px;"/></a></div>
      <!-- <div class="col s6 yo-align-right" style="height:90px;overflow:hidden;"><img src="../assets/sin.png" style="height:80px;margin-top:40px;margin-right:20px;"/></div> -->
   </div>

   <div class="row el-container" style="background:#fff !important;" v-if="$teras.app.device!='desktop'"> 
      <div class="col s6 yo-align-left" style="height:110px;overflow:hidden;"><a href="/"><img src="../assets/logo.png" style="height:90px;margin-top:10px;margin-left:20px;"/></a></div>
      <!--<div class="col s6 yo-align-right" style="height:110px;overflow:hidden;"><img src="../assets/sin.png" style="height:40px;margin-top:40px;margin-right:20px;"/></div> -->
   </div>
   
<!--
    <el-menu-item index="/loadpage/comitati/comitati" class="">Centri aderenti</el-menu-item>   <div class="row pad-in yo-text-n yo-text-bold" style="height:52px;background: #BDD1E8;">
      <div class="col s8 m9  yo-valign-text-center" style="height:52px;">INNSIN - Il nuovo network di integrazione tra Italian Neonatal Network e NNSIN</div>
      <div class="col s3 m2m yo-align-right yo-valign-text-center" style="height:52px;"><a href="#" v-on:click.prevent="$teras.event.emit('sidebarToggle')" v-if="$centro.profile.row.id>0" >{{$teras.utente.nome}} {{$teras.utente.cognome}}</a></div>
      <div class="col s1 mm yo-align-center" style="max-width:54px;"><a class="button" href="#" v-on:click.prevent="$teras.event.emit('sidebarToggle')" v-if="$centro.profile.row.id>0" ><i class="material-icons">menu</i></a></div>
      
   </div>
-->   
</div>
</template>


<script>
export default {
  name: 'site-header',
  components: {
     
  }
}
</script>
<style>
#app.device-tablet .site-header{
   
}
.site-header{
   height:160px;
   overflow:hidden;
}#app.device-mobile .site-header{
   height:110px;
}.site-header > .row > div{
   line-height:52px;    
}.site-header a{
   color:#5288C6;
   display:block;
   
}.site-header a:first{
   border-left:none !important;
}.site-header a.button i, .footer-bottom a.button i{
    line-height: 52px;
    height: 52px;
    font-size: 2.0rem;
    color:#5288C6;
    text-align:left;
}
</style>
